


















import { Vue, Component, Watch } from "@/shared/vuepack";
import { useNotifierStore } from "@/shared/store/notifier";
import { useUserStore } from "@/shared/store/user";
import IconCard from "@/employer/components/shared/IconCard.vue";
import { PRODUCTS_ICONS_MAP } from "@/shared/constants/productsIconsMap";

const UnknownErrorMessage = "Error processing your request. Please try again later";

@Component ({
components: {
    IconCard,
}
})
export default class extends Vue {
    userStore = useUserStore();
    notifierStore = useNotifierStore();
    products: any[] = [];

    get iconMap () {
        return PRODUCTS_ICONS_MAP;
    }

    async created () {
        try {
            const result = await this.userStore.getEmployerProducts();
            this.products = result.data;
        } catch (error) {
            this.handleError(error);
        }
    }

    handleError (err): void {
        this.notifierStore.setDanger(err.errorMessage || UnknownErrorMessage);
    }
}
